import * as Immutable from "immutable";
import UserModel from "./UserModel";

export default class CommentModel extends Immutable.Record({
    comment_id: 0,
    parent_id: 0,
    user: new UserModel(),
    user_name: "",
    timestamp: 0,
    content: "",
    rating: 0,
    blocked: false,
    reply_display: false,
    reply_value: "",
    reply_sending: false,
    rating_user: 0,
    expanded: false,

    level: 0,
    children: false,
    previous: false,
    first: false,
    last: false,

}) {

    public isExpanded(): boolean {
        return this.get("expanded");
    }

    public isFirst(): boolean {
        return this.get("first");
    }

    public isLast(): boolean {
        return this.get("last");
    }

    public hasChildren(): boolean {
        return this.get("children");
    }

    public hasPrevious(): boolean {
        return this.get("previous");
    }

    public getLevel(): number {
        return this.get("level");
    }

    public getCommentId(): number {
        return this.get("comment_id");
    }

    public getParentId(): number {
        return this.get("parent_id");
    }

    public getUserName(): string {
        return this.get("user_name");
    }

    public getContent(): string {
        return this.get("content");
    }

    public getRating(): number {
        return this.get("rating");
    }

    public isBlocked(): boolean {
        return this.get("blocked");
    }

    public getUser(): UserModel {
        return this.get("user");
    }

    public getTimestamp(): number {
        return this.get("timestamp");
    }

    public getRatingUser(): number {
        return this.get("rating_user");
    }

    public getReplyValue(): string {
        return this.get("reply_value");
    }

    public getReplyDisplay(): boolean {
        return this.get("reply_display");
    }

    public setRatingUser(rating: number): CommentModel {
        return this.set("rating_user", rating) as CommentModel;
    }

    public setReplyValue(value: string): CommentModel {
        return this.set("reply_value", value) as CommentModel;
    }

    public setReplyDisplay(display: boolean): CommentModel {
        return this.set("reply_display", display) as CommentModel;
    }

    public isReplySending(): boolean {
        return this.get("reply_sending");
    }

}